<div class="db-migration-rest-api-blocked">
  <h1>Unable to start the migration<br/> due to a Rest API error</h1>
  <p class="mt10">This issue can arise primarily due to Firewall/security groups, IP blocking, etc.</p>
  <div class="db-migration-steps mt25">
    <div>
      <div class="db-migration-step-count mr8">
        <div> <p class="db-migration-step-count__number">1</p> </div>
      </div>
      <p class="db-migration-step-desc">
        <a class="ds-link-blue" href="https://help.10web.io/hc/en-us/articles/12683602668818-Troubleshooting-a-blocked-REST-route">Learn how to troubleshoot REST API connection issues</a>
      </p>
    </div>
    <div class="mt15">
      <div class="db-migration-step-count mr8">
        <div> <p class="db-migration-step-count__number">2</p> </div>
      </div>
      <p class="db-migration-step-desc">Resolve the issue</p>
    </div>
    <div class="mt15">
      <div class="db-migration-step-count mr8">
        <div> <p class="db-migration-step-count__number">3</p> </div>
      </div>
      <p class="db-migration-step-desc"> Retry </p>
    </div>
  </div>
  <div class="db-migration-rest-api-blocked__btn-wrap mt30">
    <button class="ds-btn-black" (click)="migrate()">
      <span>Retry</span>
    </button>
  </div>
  <db-loading-screen [darkColor]="true" [ngClass]="{'hidden':!loading}" [pageBlocker]="true"></db-loading-screen>
</div>
<db-migration-progress
  class="hidden"
  (succeed)="showMigrationSuccessModal($event)"
  (failed)="loading = false"></db-migration-progress>
